import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import base64 from 'base-64'
import utf8 from 'utf8'

import { ivpService } from '@/services/ivp-service'
import { deviceService } from '@/services/device-service'
import { useIncidenciaStore } from '@/stores/incidencia-store'

import { UserCredentials } from '@/models/UserCredentials'
import { IncidenciaListRequest } from '@/models/IncidenciaListRequest'

const loading = ref<boolean>(false)
const errorLoad = ref<boolean>(false)

export function useIncidenciaList() {
    const store = useIncidenciaStore()

    const { incidencias, user } = storeToRefs(store)

    const needLogin = computed(() => user.value === null && deviceService.isWeb())
    const noIncidencias = computed(() => loading.value === false && errorLoad.value === false &&
                                               needLogin.value === false && incidencias.value.length === 0)


    const buildCredentials = (credentials: UserCredentials | null): string | null => {
        return credentials
            ? base64.encode(utf8.encode(JSON.stringify(credentials)))
            : null
    }

    const buildRequest = async (): Promise<IncidenciaListRequest> => {
        const uuid = await deviceService.getId()
        const credentials = buildCredentials(user.value)

        return { uuid, credentials }
    }

    const load = async () => {
        if (needLogin.value || incidencias.value.length) return

        const request = await buildRequest()
        loading.value = true

        try {
            store.incidencias = await ivpService.getIncidencias(request)
        } catch {
            errorLoad.value = true
        } finally {
            loading.value = false
        }
    }

    const retry = async () => {
        errorLoad.value = false
        await load()
    }

    return { load, retry, loading, errorLoad, needLogin, incidencias, noIncidencias }
}
